import React__default from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { createCartDiscountError } from '../types/index.js';
import { GET_CART_DISCOUNTS_BY_PROMOTION_IDENTIFIER } from '../operations/queries/get-cart-discounts-by-promotion-identifier.js';
import { mapGraphCartDiscountToClientCartDiscount } from '../mappers/server-to-client/map-to-client-cart-discount.js';

/*
 * Query the cart discounts by promotion identifier
 */ const useCartDiscounts = (promotionIdentifier, enabled = false)=>{
    const [discountError, setDiscountError] = React__default.useState(null);
    const [getCartDiscounts, { data , loading , error  }] = useLazyQuery(GET_CART_DISCOUNTS_BY_PROMOTION_IDENTIFIER);
    const mappedCartDiscounts = React__default.useMemo(()=>{
        if (!(data === null || data === void 0 ? void 0 : data.getCartDiscountsByPromotionIdentifier)) {
            return [];
        }
        return mapGraphCartDiscountToClientCartDiscount(data.getCartDiscountsByPromotionIdentifier);
    }, [
        data === null || data === void 0 ? void 0 : data.getCartDiscountsByPromotionIdentifier
    ]);
    React__default.useEffect(()=>{
        if (enabled && promotionIdentifier) {
            getCartDiscounts({
                variables: {
                    promotionIdentifier
                }
            });
        }
    }, [
        promotionIdentifier,
        enabled
    ]);
    React__default.useEffect(()=>{
        if (error) {
            setDiscountError(createCartDiscountError('CART_DISCOUNT_ERROR', error));
        }
    }, [
        error
    ]);
    return React__default.useMemo(()=>{
        return {
            loading,
            cartDiscounts: mappedCartDiscounts,
            error: discountError
        };
    }, [
        loading,
        mappedCartDiscounts,
        discountError
    ]);
};

export { useCartDiscounts };
//# sourceMappingURL=use-cart-discounts.js.map
